<script setup>
import { TresCanvas } from '@tresjs/core'
import { useGLTF, OrbitControls } from '@tresjs/cientos'
import { useRenderLoop } from '@tresjs/core'
const props = defineProps(['url', 'product'])
const { scene } = await useGLTF(props.url)
scene.scale.set(10, 10, 10)
const { onLoop } = useRenderLoop()
onLoop(() => {
  scene.rotation.y += 0.01
})
</script>

<template>
  <TresCanvas clear-color="#fff" shadows alpha preset="realistic">
    <TresPerspectiveCamera :look-at="[0, 0, 0]" />
    <OrbitControls :enableZoom="false" />

    <TresScene>
      <TresAmbientLight :color="0xffffff" :intensity="1" />
      <primitive :object="scene" :position="[0, -1, 0]" />
    </TresScene>
  </TresCanvas>
</template>
